import React from 'react';
import Card from '.';
import Grid from '../Grid/Grid';
import TitleContent from '../../../views/Request/TransactionRequest/ApproveRejectContent/components/TitleContent';
import { useAppSelector } from '../../../reducer/hooks';
import { selectIsMobileView } from '../../../reducer/mediaSlice';
import { useGenGridCol } from '../../../utils/ComponentHelper';
import { TransactionOperationTableColumnKey } from '../../../views/Request/TransactionRequest/ApproveRejectContent/types/TransactionOperationTable';
import { EnumOperationType } from '../../../enum/EnumOperationType';

interface IProps {
  rows: any[];
  columns: ReturnType<typeof useGenGridCol>[];
  marginBottom?: string;
  columnWidths?: string[];
  cardBackgroundColor?: string;
  gap?: string;
  columnsGap?: string;
  customComponent?: React.ReactNode;
  cardColumns?: number;
}

const CardList = (props: IProps) => {
  const {
    rows,
    columns,
    marginBottom,
    columnWidths,
    cardBackgroundColor,
    gap,
    columnsGap,
    customComponent,
    cardColumns,
  } = props;
  const isMobile = useAppSelector(selectIsMobileView);
  const spacing = marginBottom || '24px';

  const desktopColumnCount = cardColumns || 2;
  const desktopWrapperStyle = !isMobile
    ? {
        display: 'grid',
        gridTemplateColumns: `repeat(${desktopColumnCount}, minmax(0, 1fr))`,
        gap: spacing,
      }
    : undefined;

  const listContent = rows.map((row, index) => {
    return (
      <div style={isMobile ? { marginBottom: spacing } : undefined} key={index}>
        <Card backgroundColor={cardBackgroundColor || '#2a2a2a'}>
          <Grid
            columns={2}
            columnWidths={columnWidths || ['120px', '1fr']}
            gap={gap}
            columnGap={columnsGap}
          >
            {columns.map((column, index) => {
              if (column.hide) return null;

              const value = row[column.field as keyof any];
              const content = column.renderCell
                ? column.renderCell({ value, row, field: column.field } as any)
                : value || '';

              // Operation List - hide path field for non-uniswap operations
              if (
                row?.rawData?.operationType !== EnumOperationType.Uniswap &&
                column.field === TransactionOperationTableColumnKey.Path
              ) {
                return <></>;
              }

              return <TitleContent key={index} title={column.headerName || ''} content={content} />;
            })}
          </Grid>

          {customComponent}
        </Card>
      </div>
    );
  });
  return isMobile ? <>{listContent}</> : <div style={desktopWrapperStyle}>{listContent}</div>;
};

export default CardList;
